<template>
  <LoginHolder>
    <h2 class="mb-1">Create New Account</h2>
    <p class="pb-3">Sign up now and unlock exclusive access!</p>
    <ValidationObserver ref="observer">
      <form
        ma-8
        v-on:submit.prevent>
        <v-container class="container-bg-color pa-0" fluid fill-height>

          <v-row align="center" style="height:100%">
            <v-col cols="12">
              <AlertMessage :alerMessage="alerMessage"></AlertMessage>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <ValidationProvider v-slot="{ errors }" name="First Name" rules="required">
                <v-text-field
                  v-model="user.first_name"
                  maxlength="100"
                  :error-messages="errors"
                  label="First Name"
                  required
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required">
                <v-text-field
                  v-model="user.last_name"
                  maxlength="100"
                  :error-messages="errors"
                  label="Last Name"
                  required
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <ValidationProvider v-slot="{ errors }" name="Email Address" rules="required|email">
                <v-text-field
                  v-model="user.email"
                  maxlength="100"
                  :error-messages="errors"
                  label="Email Address"
                  hint="* Required (e.g. juan.delacruz@email.com)"
                  show-details
                  required
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <ValidationProvider v-slot="{ errors }" name="Tel / Mobile No." rules="required">
                <v-text-field
                  v-model="user.contact_no"
                  maxlength="100"
                  :error-messages="errors"
                  label="Tel / Mobile No."
                  required
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="12" md="6" class="d-none">
              <v-text-field
                v-model="user.sales_agent"
                maxlength="100"
                label="Sales Agent Code"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <ValidationProvider v-slot="{ errors }" name="Address" rules="required">
                <v-textarea
                  v-model="user.address"
                  label="Address"
                  :error-messages="errors"
                  auto-grow
                  rows="1"
                  maxlength="255"
                  required
                ></v-textarea>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <ValidationProvider v-slot="{ errors }" name="Password" rules="required|min:6">

                <v-text-field
                  v-model="user.password"
                  :append-icon="passShow ? 'mdi-eye' : 'mdi-eye-off'"
                  :error-messages="errors"
                  :type="passShow ? 'text' : 'password'"
                  name="input-10-2"
                  label="Password"
                  ref="password"
                  autocomplete="false"
                  class="input-group--focused mt-3"
                  @click:append="passShow = !passShow"
                ></v-text-field>


              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <ValidationProvider v-slot="{ errors }" name="Confirm Password" rules="required|confirmed:Password|min:6">

                <v-text-field
                  v-model="user.confirm_password"
                  :append-icon="confirmPassShow ? 'mdi-eye' : 'mdi-eye-off'"
                  :error-messages="errors"
                  autocomplete="false"
                  :type="confirmPassShow ? 'text' : 'password'"
                  name="input-10-2"
                  label="Confirm Password"
                  class="input-group--focused mt-3"
                  @click:append="confirmPassShow = !confirmPassShow"
                ></v-text-field>

              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <ValidationProvider v-slot="{ errors }" name="Terms and Conditions" rules="required">

                <v-checkbox
                  v-model="user.terms_and_conditions"
                  :error-messages="errors">
                  <template v-slot:label>
                    <div>
                      I agree to the
                      <a
                        target="_blank"
                        href="/terms-and-conditions"
                        @click.stop
                      >
                        Terms and Conditions
                      </a>
                    </div>
                  </template>
                </v-checkbox>

              </ValidationProvider>
            </v-col>
          </v-row>
        </v-container>
      </form>
    </ValidationObserver>

    <v-btn
      depressed
      block
      rounded
      large
      :disabled="loading"
      class="mb-8 mt-6"
      color="primary"
      @click="register()"
    >
      <span v-if="loading" class="mx-4">Please wait...</span>
      <span v-if="!loading" class="mx-4">Create Account</span>
    </v-btn>

    <v-btn
      depressed
      block
      rounded
      large
      :disabled="loading"
      :to="{ name: 'login' }"
    >
      Login
    </v-btn>
    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
  </LoginHolder>
</template>

<script>
  import { mapGetters } from "vuex";
  import { required, email, confirmed, min } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import LoginHolder from './LoginHolder.vue'
  import AlertMessage from '@/components/AlertMessage.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  extend('min', {
    ...min,
    message: '{_field_} must be at least {length} characters',
  })

  extend('email', {
    ...email,
    message: '{_field_} must be a valid email',
  })

  extend("confirmed", {
    ...confirmed,
    message: "The password does not match",
  });

  export default {
    name: 'CreateNewAccount',
    data: () => ({
      passShow: false,
      confirmPassShow: false,
      user: {
        first_name: '',
        last_name: '',
        email: '',
        address: '',
        contact_no: '',
        sales_agent: '',
        password: '',
        confirm_password: '',
        terms_and_conditions: ''
      },
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      loading: false
    }),
    computed: {
      ...mapGetters(['getFirstLoad', 'getCategories', 'getUsers', 'capitalise']),
    },
    methods: {
      async register (){
        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          return false;
        }

        if(this.loading){
          return false;
        }

        this.loading = true
        let self = this

        this.$http.secured.post('/users/register', this.user)
          .then(response => {
            this.$router.push({ name: 'confirm-registration', query: { email: this.user.email } })
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })


      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
    },
    mounted() {
      if(this.$route.params.code){
        this.user.sales_agent = this.$route.params.code
      }
    },
    components: {
      SnackBar,
      ValidationProvider,
      ValidationObserver,
      LoginHolder,
      AlertMessage
    },
  }
</script>
